<template>
    <div class="w-full">
        <div v-if="error != ''"
        class="mx-auto mn3-alert p-2 my-2 rounded-sm flex flex-row items-center">
            <Icon id="exclamation" class="h-6 w-6 mr-2" />
            <span v-html="error" />        
        </div>
        <div v-if="openInBrowser && !locked" class="max-w-screen-lg w-full mx-5 mt-24" >
            <div v-if="alliedUrl != ''" class="p-2 cursor-pointer mn3-button mn3-submit rounded-sm block flex" @click="openUrl">
                <Icon class="h-6 w-6 mr-2" id="export" />Please click here to open {{titleToUse}}.
            </div>
        </div>
        <div v-else-if="!locked" class="max-w-screen-lg w-full" >
            <iframe id="frame" :src="alliedUrl" :style="frameHeight" class="w-full md:rounded" />
        </div>
    </div>
</template>
<script>
    import { useRouter } from "vue-router"
    import { ref, computed } from 'vue'

    import Icon from '@/components/Icon.vue'

export default{
    components:{
        Icon
    },
    props:{
        mode: {
            type: String,
            default: 'allied'
        }
    },
    computed:{
        titleToUse(){
            if(this.$props.mode == 'allied2')
                return this.$store.state.fi.allied2Title;

            return this.$store.state.fi.alliedTitle;
        }
    },
    async created(){
        document.title = this.titleToUse

        this.frameHeightUpdate++;
        window.addEventListener("resize", this.windowResize);

        //Check for exiting screen if not enabled
        if((!this.$store.state.fi.alliedEnabled && this.$props.mode == 'allied') ||
            (!this.$store.state.fi.allied2Enabled && this.$props.mode == 'allied2')){
            this.$router.push('/');
        }else{
            this.fetchAllied();
        }
    },
    methods: {
        async fetchAllied(){

            let fetched;
            let fail = false;

            try{
                let url = "allied-sso";
                if(this.$props.mode == 'allied2')
                    url = "allied2-sso";

                fetched = await this.$mapi.get(url)
            }catch(e){
                fail = true;
                if(e.response && e.response.data && e.response.data.errors){
                  this.error = e.response.data.errors[0].detail;
                }else{
                  this.error = e;
                }
            }

            if(!fail && (fetched.data.data.attributes.restrictedExpires || fetched.data.data.attributes.restrictedMessage)){
                this.locked = true
                this.error = fetched.data.data.attributes.restrictedMessage + '<br /><br /> Restriction expires: ' + this.dateDisplay(fetched.data.data.attributes.restrictedExpires);
            }else if(!fail){

                this.alliedSso = fetched;
                this.alliedUrl = fetched.data.data.attributes.url;     
                
                //Check if embed is false
                if(fetched.data.data.attributes.embed == false){
                    this.openInBrowser = true;
                }
            }
            
        },
        dateDisplay(raw){            
            return new Date(raw + 'Z').toLocaleDateString('en-us', {hour: 'numeric', minute: 'numeric', hour12: true, month: 'short', day:'numeric', timeZoneName: 'short'});
        }, 
        windowResize(e){
            this.frameHeightUpdate++;
        }
    },
    setup(){
        const alliedSso = ref("");
        const alliedUrl = ref("");
        const error = ref("");
        const openInBrowser = ref(false)
        const locked = ref(false);

        const frameHeightUpdate = ref(0)
        const frameHeight = computed({          
            get: () => {
                frameHeightUpdate.value++;      
                    
                if(window.innerWidth >= 768)                 
                    return `height: ${window.innerHeight-225}px;`;      
                else 
                    return `height: ${window.innerHeight-132}px;`;           
            }
        });
        function openUrl(){
              window.open(alliedUrl.value);
        }

        return {
            error,
            alliedSso,
            alliedUrl,
            frameHeight,
            frameHeightUpdate,       
            locked,     
            openInBrowser,
            openUrl
        }
    }
}
</script>
